import ReadingType from '../ReadingType'
import EventType from '../EventType'

export default {
  ReadingType,
  EventType,
}
